import { connect } from 'react-redux';
import * as R from 'ramda';
import PrimaryStep1 from './PrimaryStep1';
import { getStoreValueByProp } from '../../store/sequencingWizardSlice';

const mapState = R.applySpec({
  loading: getStoreValueByProp(['inventoryOwnersLoading']),
});

export default connect(mapState, {})(PrimaryStep1);
